import { useCallback, useMemo } from 'react';

import { AdminParameterModel } from 'types/admin/trackmanParameters';
import { Checkbox } from '@trackman/web-shared-components';
import { LanguageType } from 'types/languages';
import { useGetLanguages } from 'queryHooks/language';

type Props = {
  dataItem: AdminParameterModel;
  enableEnglish?: boolean;
  addTitle?: boolean;
};

export const LanguageCheckboxes = ({ dataItem, enableEnglish, addTitle }: Props) => {
  const { data: languages } = useGetLanguages();

  const lngCheckboxesData = useMemo(() => {
    return languages?.map((lng) => {
      return {
        ...lng,
        checked: dataItem.languages.includes(lng.countryCode),
      };
    });
  }, [languages, dataItem.languages]);

  const handleCheckboxChange = useCallback(
    (countryCode: LanguageType) => {
      let index = dataItem.languages.indexOf(countryCode);

      if (index > -1) {
        dataItem.languages.splice(index, 1);
        if (!addTitle) return;

        if ('titles' in dataItem && dataItem.titles) {
          dataItem.titles.splice(index, 1);
        }
        if ('definitions' in dataItem && dataItem.definitions) {
          dataItem.definitions.splice(index, 1);
          dataItem.usageInfo.splice(index, 1);
          dataItem.articlesInfo?.splice(index, 1);
        }
      } else {
        dataItem.languages.push(countryCode);
        if (!addTitle) return;

        if ('titles' in dataItem && dataItem.titles) {
          dataItem.titles.push({ countryCode: countryCode, text: '' });
        }
        if ('definitions' in dataItem && dataItem.definitions) {
          dataItem.definitions.push({ countryCode: countryCode, text: '' });
          dataItem.usageInfo.push({ countryCode: countryCode, text: '' });
          dataItem.articlesInfo?.push({ countryCode: countryCode, text: '' });
        }
      }
    },
    [dataItem, addTitle]
  );

  return (
    <div className='admin-edit-section'>
      <h2>Language</h2>
      <div className='checkboxes-container'>
        {lngCheckboxesData?.map((lng) => {
          return (
            <Checkbox
              key={lng.countryCode}
              label={lng.displayName}
              disabled={!enableEnglish ? lng.countryCode === 'en-US' : false}
              onChange={() => handleCheckboxChange(lng.countryCode)}
              checked={dataItem.languages.includes(lng.countryCode)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default LanguageCheckboxes;
